import { useTranslation } from 'react-i18next';
import { api } from '../../services/api';
import { useAsync } from '../../hooks/useAsync';
import { useQueryParams } from '../../hooks/useQueryParams';
import { dateTime } from '../../services/format';
import type { WaitlistRole } from '../../types/api';
import { Alert, Cell, Field, Filters, Input, PageTitle, Pager, Row, Select, Table } from '../../components/ui';

const PAGE_SIZE = 50;
const ROLES: WaitlistRole[] = ['modeller', 'lender', 'investor', 'advisor', 'other'];

/** The website's Project Finance Agent waiting list (sculpt-api `GET /admin/waitlist`), newest first. */
export function WaitlistList() {
  const { t, i18n } = useTranslation();
  const { get, page, set, reset, setPage } = useQueryParams();
  const role = get('role');
  const email = get('email');
  const { data, error, loading } = useAsync(() => api.waitlist({ role: role || undefined, email: email || undefined, page, page_size: PAGE_SIZE }), [role, email, page]);

  return (
    <div>
      <PageTitle title={t('waitlist.title')} subtitle={data ? `${t('waitlist.subtitle')} · ${t('common.count', { count: data.total })}` : t('waitlist.subtitle')} />
      <Filters onReset={reset}>
        <Field label={t('waitlist.role')}>
          <Select value={role} onChange={(e) => set({ role: e.target.value })}>
            <option value="">{t('common.any')}</option>
            {ROLES.map((r) => (
              <option key={r} value={r}>
                {t(`waitlist.roles.${r}`)}
              </option>
            ))}
          </Select>
        </Field>
        <Field label={t('waitlist.email')} className="w-64">
          <Input value={email} onChange={(e) => set({ email: e.target.value })} />
        </Field>
      </Filters>
      {error && <Alert>{error}</Alert>}
      <Table head={['#', t('waitlist.email'), t('waitlist.role'), t('waitlist.lang'), t('waitlist.createdAt')]} empty={loading ? t('common.loading') : t('common.empty')}>
        {(data?.items ?? []).map((s) => (
          <Row key={s.id}>
            <Cell mono>{s.id}</Cell>
            <Cell mono>{s.email}</Cell>
            <Cell>{t(`waitlist.roles.${s.role}`)}</Cell>
            <Cell mono>{s.lang}</Cell>
            <Cell mono>{dateTime(s.created_at, i18n.language)}</Cell>
          </Row>
        ))}
      </Table>
      {data && <Pager page={data.page} pageSize={data.page_size} total={data.total} onPage={setPage} />}
    </div>
  );
}
